export default "__VITE_ASSET__DOZhCOGv__"